/**
 * Shared types and response parsing for PUT label_separation (any source with the same body/response).
 */
import {
  LabelRangePayload,
  LabelSeparationSaveResult
} from '../components/Common/LabelSeparation/types';
import { HttpStatus } from './httpStatus';

const DEFAULT_SAVE_ERROR = 'Failed to save label separation';

export type LabelSeparationPutBody = {
  ranges: LabelRangePayload[];
};

const extractErrorMessage = (response: any): string => {
  const message = response?.data?.message;
  if (typeof message === 'string' && message.trim()) {
    return message;
  }

  if (response?.status) {
    return `${DEFAULT_SAVE_ERROR} (${response.status})`;
  }

  return DEFAULT_SAVE_ERROR;
};

/** Normalize PUT label_separation HTTP response into ok/message for UI alerts. */
export const resolveLabelSeparationSaveResponse = (response: any): LabelSeparationSaveResult => {
  if (!response) {
    return { ok: false, message: 'Unable to reach the server. Please try again.' };
  }

  if (response.status === HttpStatus.OK && response.data?.error !== true) {
    const successMessage = response.data?.Success?.message;
    return {
      ok: true,
      message: typeof successMessage === 'string' ? successMessage : 'Saved successfully'
    };
  }

  return { ok: false, message: extractErrorMessage(response) };
};
